// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v8no","badges":"styles_badges__dDl-O"};